function setupTabsAndAccordion() {
  // Tabs
  const tabs = document.querySelector(".product-info-tab-item");
  const tabButtons = document.querySelectorAll(
    ".product-info-tab-item .nav-item"
  );
  const tabContents = document.querySelectorAll(
    ".product-info-tab-item .tab-pane"
  );

  if (tabs) {
    tabs.onclick = (e) => {
      const id = e.target.dataset.id;
      if (id) {
        tabButtons.forEach((btn) => btn.classList.remove("active"));
        e.target.classList.add("active");
        tabContents.forEach((content) => content.classList.remove("active"));
        const element = document.getElementById(id);
        if (element) element.classList.add("active");
      }
    };
  }

  // Lazy load and serve responsive images inside tab content (below the fold)
  document.querySelectorAll(".product-info-tab-item .tab-pane img").forEach((img) => {
    img.setAttribute("loading", "lazy");
    img.setAttribute("fetchpriority", "low");
  });

  // Accordion
  document.querySelectorAll(".accordion-wrapper").forEach((wrapper) => {
    wrapper.addEventListener("click", function () {
      this.classList.toggle("open");
      const content = this.querySelector(".accordion-content");
      const icon = this.querySelector(".accordion-icon");
      if (this.classList.contains("open")) {
        content.style.display = "block";
        icon.textContent = "-";
      } else {
        content.style.display = "none";
        icon.textContent = "+";
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", setupTabsAndAccordion);
document.addEventListener("shopify:section:load", setupTabsAndAccordion);
